import { NotificationSwitcher } from '@core/model/framework/notifications/notificationSwitcher';
import {
  WaitOnWebauthNotificationGateway,
  WaitOnWebauthNotificationGatewayInput,
  WaitOnWebauthNotificationGatewayOutput,
} from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

@injectable()
export class WaitOnWebauthNotificationSwitcher implements WaitOnWebauthNotificationGateway {
  constructor(@inject(SERVICE_ID.notificationSwitcher) private notificationSwitcher: NotificationSwitcher) {}

  awaitNewBankConnection(
    input: WaitOnWebauthNotificationGatewayInput
  ): WaitOnWebauthNotificationGatewayOutput {
    return this.notificationSwitcher.getWaitOnWebauthNotificationGateway().awaitNewBankConnection(input);
  }

  stopWaitingNewBankConnection(): void {
    this.notificationSwitcher.getWaitOnWebauthNotificationGateway().stopWaitingNewBankConnection();
    return;
  }
}
